import React, { useState } from 'react';
import { Navbar, Nav, Button, Container } from 'react-bootstrap';
import logo from '../../Assets/Svgs/logo.svg';
import './Navbar.scss';
import AlertComponent from '../AlertComponent';
import { Link } from 'react-router-dom';

export default function CustomNavbar() {



  return (
    <Navbar bg='dark' expand='lg' variant='dark' className='py-3 px-3'>
      <Container>
        {/* Logo and SVG Icon */}
        <div className='d-flex align-items-center'>
         
          
            <img src={logo} alt='MyApp Logo' style={{ height: '40px' }}/>
       
        </div>

        {/* Mobile Toggle Button */}
        <Navbar.Toggle
          aria-controls='basic-navbar-nav'
          className='border-0 shadow-none custom-toggler'
        />

        {/* Navbar Items */}
        <Navbar.Collapse id='basic-navbar-nav'>
          <Nav className='ms-auto d-flex align-items-end gap-3 p-2'>
            <Link to='/login'>
              <Button variant='outline-light' className='rounded-pill px-4'>
                Sign In
              </Button>
            </Link>
            <Link to="/sign-up">
            <Button variant='primary' className='rounded-pill px-4'>
              Sign Up
            </Button>
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
